import main from 'ui/styles/StyledComponentsTheme/themes/main';

const themes = {
  main,
};

export default themes;
